import store from '../store'
import { API_URL,websocket_API_URL } from '@/utils/url'
import { MessageBox, Message } from 'element-ui'
import { GetMessageSumAPI } from "@/request/message/api";

async function  getMessageSum() {
    if (!localStorage.getItem("user-token")) {
      return;
    }
    let info = await GetMessageSumAPI();
    if (info&&info.code == 200) {
      store.commit("changeMsgSum", info.data);
    }
  }
// 创建一个单例模式类
export class WebSocketSingleton {

    static getInstance() {
        getMessageSum();
        if (localStorage.getItem("user-token")) {
            this.instance = new WebSocket(
                `${websocket_API_URL}/websocket/user/${localStorage.getItem("user-token")}`
                // , [localStorage.getItem("user-token"), '1']
            );


            this.instance.onopen = () => {
                console.log("websocket连接成功");
            };

            this.instance.onmessage = async (msg) => {
                store.commit('changeMessage', msg)

            };
            this.instance.onclose = (e) => {
                console.log("websocket连接关闭");
                console.log('关闭状态码：' + e.code);
                console.log('关闭原因：' + e.reason);
                
                if (!store.state.isServerReconnection) {
                    return;
                }
                if(!localStorage.getItem("user-token")){
                    return;
                }
                MessageBox.confirm('与服务器断开连接，是否重新连接？', '系统提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                
                    this.getInstance();
                }).catch(() => {

                });

            };
            this.instance.onerror = (error) => {

                console.log("websocket发生错误："+error);

            };
            store.state.webSocket=this.instance;
           
        }

        return this.instance
    }
    static close() {
        if(this.instance){
            store.state.isServerReconnection= false;
            this.instance.close();
            store.state.isServerReconnection= true;
        }
 
    }

}




